import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAnnouncementDismissed.meta';

export type UseTrackAnnouncementDismissedParams = {
  announcement_id: string;
  name: string;
  surface: 'global' | 'assetDetails' | 'canvas' | 'canvasNullState' | 'canvasChatComposer' | 'boards' | 'plans';
};

export const useTrackAnnouncementDismissed = () => {
  const { track } = useAnalyticsUtilities();

  const trackAnnouncementDismissed = useCallback(
    (params: UseTrackAnnouncementDismissedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackAnnouncementDismissed };
};
